import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getBlogBySlug } from "../../api/axios";
import DynamicBreadcrumb from "../common/DynamicBreadcrumb";
import DynamicImage from "../common/DynamicImage";

export default function BlogDetail() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    getBlogBySlug(slug).then(setBlog);
  }, [slug]);

    // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return ""

    // Handle "YYYY-MM-DD HH:mm:ss"
    const safeDate = dateString.includes(" ")
      ? dateString.split(" ")[0]
      : dateString

    const date = new Date(safeDate)
    if (isNaN(date.getTime())) return ""

    const day = date.getDate()
    const month = date.toLocaleString("en-US", { month: "long" })
    const year = date.getFullYear()

    return `${day} ${month} ${year}`
  }

    // Clean HTML content
  const cleanHtml = (html) => {
    if (!html) return ''
    let cleaned = html.replace(/<img/g, '<img class="blog-content-image"')
    cleaned = cleaned.replace(/<table/g, '<div class="table-wrapper"><table')
    cleaned = cleaned.replace(/<\/table>/g, '</table></div>')
    return cleaned
  }

  if (!blog) return <p>Loading…</p>;


  return (
    <>
      <DynamicBreadcrumb />

      <div className="blog-details-area ptb-100">
        <div className="container">
          <div className="row justify-content-center">
            <main className="col-lg-11 col-md-12">
              <div className="blog-details-desc">
                {blog.image && (
                  <div className="article-image-container">
                    <div className="image-wrapper">
                      <DynamicImage image={blog.image} className="article-featured-image" />
                    </div>
                  </div>
                )}

                {/* Article Header */}
                <header className="article-header">
                  <div className="article-meta">
                    {blog.category && (
                      <span className="article-category">
                        <i className="flaticon-user fw-bold"></i>
                        Cyblox
                      </span>
                    )}
                    {blog.publishedAt && (
                      <span className="article-date article-category">
                        <i className="flaticon-calendar fw-bold"></i>
                        {formatDate(blog.publishedAt)}
                      </span>
                    )}

                  </div>

                  <h1 className="article-title">{blog.title}</h1>
                </header>

                {/* Article Content */}
                <div className="article-content">
                  {blog.description ? (
                    <div
                      dangerouslySetInnerHTML={{ __html: cleanHtml(blog.description) }}
                      className="article-body"
                    />
                  ) : (
                    <div className="no-content">
                      <p>Content coming soon...</p>
                    </div>
                  )}
                </div>

              </div>
            </main>
          </div>
        </div>
      </div>
    </>
  );
}
